import type { SVGProps } from 'react';

const SvgConsentManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="consent-management">
      <path d="M20.59.31H5.65A2.75 2.75 0 0 0 2.9 3.06v25.76a2.75 2.75 0 0 0 2.75 2.75h21.68a2.75 2.75 0 0 0 2.75-2.75V9.73a.75.75 0 0 0-.22-.53L21.11.53a.74.74 0 0 0-.52-.22m.65 2.46 6.48 6.43h-5.29a1.23 1.23 0 0 1-.88-.37A1.2 1.2 0 0 1 21.2 8Zm6.09 27.3H5.65a1.25 1.25 0 0 1-1.25-1.25V3.06a1.25 1.25 0 0 1 1.25-1.25h14.1l-.05 6.13a2.73 2.73 0 0 0 2.73 2.76h6.15v18.12a1.25 1.25 0 0 1-1.25 1.25" />
      <path d="m14.67 20.9-2.41-2.41-1.06 1.06 2.94 2.94a.74.74 0 0 0 .53.22.77.77 0 0 0 .53-.21l8.45-8.42L22.59 13Z" />
      <path d="M20.43 19a5.8 5.8 0 0 1 .15 1.31 5.86 5.86 0 1 1-2.58-4.9l.84-1.24a7.35 7.35 0 1 0 3.23 6.09 7.5 7.5 0 0 0-.18-1.64Z" />
    </g>
  </svg>
);

export default SvgConsentManagement;
